
import React, { Component } from 'react';
import { Modal, Row, Divider, Button, Table, Descriptions } from 'antd';

const fields = [{
    "text": "竞价车辆",
    "field": "vehicleIdsStr",
}, {
    "text": "竞价品名称",
    "field": "name",
}, {
    "text": "竞价品编号",
    "field": "code",
}, {
    "text": "起始价",
    "field": "startPrice",
}, {
    "text": "保留价",
    "field": "reservePrice",
}, {
    "text": "保证金",
    "field": "bond",
    // }, {
    //     "text": "服务费",
    //     "field": "serviceChargeDictStr",
}, {
    "text": "竞价开始时间",
    "field": "startTime",
}, {
    "text": "竞价结束时间",
    "field": "endTime",
}, {
    "text": "结果",
    "field": "status",
    format: { 0: '无人出价', 1: '成功', 2: '低于保留价', 3: '竞价成功，但没有成交' }
}, {
    "text": "中标商户",
    "field": "memberName",
}, {
    "text": "最终价格",
    "field": "finalPrice",
}, {
    "text": "服务费",
    "field": "serviceCharge",
}, {
    "text": "过户费",
    "field": "tradeCharge",
}, {
    "text": "到账日期",
    "field": "collectionDate",
}, {
    "text": "交接情况",
    "field": "handoverStr",
    "span": 2
}, {
    "text": "备注",
    "field": "remark",
    "span": 2
}];


class AuctionLotsDetail extends Component {
    columns = [{
        title: '出价时间',
        dataIndex: 'bidTime',
        width: '10%',
    }, {
        title: '出价人',
        dataIndex: 'memberName',
        width: '15%',
    }, {
        title: '报价',
        dataIndex: 'offer',
        width: '10%',
    }];

    render() {
        const { visible, onCancel, editData } = this.props;
        return (
            <Modal
                width={900}
                visible={visible}
                title="竞价信息详情"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                footer={[
                    <Button key="take" type="primary" onClick={onCancel}>确定</Button>,
                ]}
            >
                <Descriptions title="" bordered column={2}>
                    {fields.map((item, index) => {
                        let val = editData[item.field]
                        if (item.format) {
                            val = item.format[val];
                        }
                        if (item.field === "vehicleIdsStr" && val != null) {
                            val = val.replaceAll(",", "\n");
                            val = <pre style={{ margin: "0px", whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{val}</pre>
                        }
                        return <Descriptions.Item key={index} label={item.text} span={item["span"] ? item["span"] : 1}>{val}</Descriptions.Item>
                    })}
                </Descriptions>
                <Row>
                    <Divider orientation="left">出价记录列表</Divider>
                    <Table
                        rowKey="id"
                        columns={this.columns}
                        dataSource={this.props.editData.bidRecords}
                        pagination={{ pageSize: 5 }}
                        bordered={true}
                    />
                </Row>
            </Modal>
        );
    }
}


export default AuctionLotsDetail;